import type {
  FormattedAlert,
  GetChannelDetailsResponse
} from '@library/types/alerts';
import { Avatar } from '@library/components/avatar/Avatar';
import { Button } from '@library/components/buttons';
import { ChannelUsersModal } from '@bo-components/alerts/ChannelUsersModal';
import { MessageBanner } from '@library/components/banners/MessageBanner';
import addIcon from '@library/assets/images/icons/user-add-icon.svg';
import { formatDate } from '@library/component-utils/dateTime';
import { useState } from 'react';

export interface AlertProps {
  alert: FormattedAlert;
  channelDetails: GetChannelDetailsResponse | undefined;
  selectedChannelId: number;
}

export const Alert = ({
  alert,
  channelDetails,
  selectedChannelId
}: AlertProps) => {
  const { firstName, lastName, text, id } = alert;

  const [channelUsersModalOpen, setChannelUsersModalOpen] = useState(false);

  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const first = firstName || 'No';
  const last = lastName || 'Username';

  const time = formatDate({ date: alert.timestamp, pattern: 'hh:mm a' });

  const closeModal = () => {
    setChannelUsersModalOpen(false);
  };

  return (
    <div className="group flex min-h-9 w-full items-start gap-4 px-4 py-2">
      {isError && (
        <MessageBanner
          code="ERROR"
          message="Error tagging user"
          onCancel={() => setIsError(false)}
        />
      )}
      {isSuccess && (
        <MessageBanner
          code="SUCCESS"
          message="Successfully tagged user"
          onCancel={() => setIsSuccess(false)}
        />
      )}
      <Avatar />
      <div className="flex w-full flex-col gap-2">
        <div className="flex h-4 w-auto items-center gap-2">
          <p className="text-soClean-100">{`${first} ${last}`}</p>
          <p className="text-soClean-180 h-[15px] text-xs font-[450px]">
            {time}
          </p>
          <Button
            onClick={() => setChannelUsersModalOpen(true)}
            className="invisible size-4 p-0 group-hover:visible"
          >
            <img className="h-4" src={addIcon} alt="tag a user" />
          </Button>
        </div>
        <p className="text-soClean-140 text-sm font-[450px] leading-4">
          {text}
        </p>
      </div>
      <ChannelUsersModal
        channelDetails={channelDetails}
        isOpen={channelUsersModalOpen}
        selectedChannelId={selectedChannelId}
        setIsError={setIsError}
        setIsSuccess={setIsSuccess}
        alertId={id}
        onCancelModal={closeModal}
      />
    </div>
  );
};
